import { atom } from 'jotai';
import { useEffect, useId, useSyncExternalStore } from 'react';
import jotaiStore from '../jotai-store.js';
// The amounts the user has clicked, keyed by the Money element showing each
const selectedAtom = atom(new Map());
export const getSelectedAmounts = () => Array.from(jotaiStore.get(selectedAtom).values());
export const toggleAmount = (id, amount) => jotaiStore.set(selectedAtom, (selected) => {
    const next = new Map(selected);
    if (!next.delete(id)) {
        next.set(id, amount);
    }
    return next;
});
export const updateAmount = (id, amount) => jotaiStore.set(selectedAtom, (selected) => selected.has(id) && selected.get(id) !== amount
    ? new Map(selected).set(id, amount)
    : selected);
export const removeAmount = (id) => jotaiStore.set(selectedAtom, (selected) => {
    if (!selected.has(id)) {
        return selected;
    }
    const next = new Map(selected);
    next.delete(id);
    return next;
});
export const clearAmounts = () => jotaiStore.set(selectedAtom, new Map());
// Not useAtomValue: it renders every Money twice on mount
const subscribe = (listener) => jotaiStore.sub(selectedAtom, listener);
export const useMoneyCalculatorItem = (amount) => {
    const id = useId();
    const isSelected = useSyncExternalStore(subscribe, () => jotaiStore.get(selectedAtom).has(id));
    useEffect(() => updateAmount(id, amount), [id, amount]);
    useEffect(() => () => removeAmount(id), [id]);
    return { isSelected, toggle: () => toggleAmount(id, amount) };
};
export const useMoneyCalculator = () => {
    const selected = useSyncExternalStore(subscribe, () => jotaiStore.get(selectedAtom));
    return Array.from(selected.values());
};
//# sourceMappingURL=index.js.map